import { DIID } from "@archipad-js/dependency-injection";

import { AbilityService } from "./ability.service";
import { PureAbility } from "@casl/ability";

export const Ability_DIID = DIID<PureAbility>("Ability");
export const Ability_Service_DIID = DIID<AbilityService<PureAbility>>("AbilityService");
